export default __webpack_public_path__ + "static/media/Soberano.86b46d70.jpg";